/* Configurador de la coleccion Classic.
   Un solo producto a la vista: el selector de diseno cambia de producto, el de
   color cambia de variante, y la imagen sigue a los dos. Lo que se anade al
   carrito es siempre la variante que se esta viendo. */
(function () {
  'use strict';

  /* Puede haber mas de un panel en la pagina: la ficha de producto trae el suyo
     y el modal de compra rapida inyecta otro al abrirse. Antes esto cogia el
     primero del documento con querySelector y se ejecutaba una sola vez al
     cargar, asi que el del modal se quedaba vacio y ademas mostraba el precio
     del producto de la ficha. Ahora se arranca uno por raiz, y se vigila el DOM
     para inicializar los que aparezcan despues. */

  /** El bloque de datos es hermano posterior de la raiz, no va dentro. */
  function datosDe(raiz) {
    var n = raiz.nextElementSibling;
    while (n) {
      if (n.matches && n.matches('[data-sx-datos]')) return n;
      if (n.querySelector) {
        var dentro = n.querySelector('[data-sx-datos]');
        if (dentro) return dentro;
      }
      n = n.nextElementSibling;
    }
    // Por si algun dia se mueve dentro de la raiz o a otro punto del padre.
    return raiz.querySelector('[data-sx-datos]') ||
      (raiz.parentElement ? raiz.parentElement.querySelector('[data-sx-datos]') : null);
  }

  function iniciarTodos(ambito) {
    var raices = (ambito || document).querySelectorAll('[data-configurador]');
    Array.prototype.forEach.call(raices, function (raiz) {
      if (raiz.getAttribute('data-sx-iniciado') === '1') return;
      var bloque = datosDe(raiz);
      if (!bloque) return;
      raiz.setAttribute('data-sx-iniciado', '1');
      iniciar(raiz, bloque);
    });
  }

  iniciarTodos();

  /* El modal de compra rapida se inyecta despues de cargar la pagina. */
  if (window.MutationObserver && document.body) {
    new MutationObserver(function (cambios) {
      for (var i = 0; i < cambios.length; i++) {
        var nuevos = cambios[i].addedNodes;
        for (var j = 0; j < nuevos.length; j++) {
          var n = nuevos[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('[data-configurador]')) { iniciarTodos(n.parentNode); continue; }
          if (n.querySelector && n.querySelector('[data-configurador]')) iniciarTodos(n);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  function iniciar(raiz, bloque) {
  var datos;
  try {
    datos = JSON.parse(bloque.textContent);
  } catch (e) {
    return;
  }
  if (!datos.designs || !datos.designs.length) return;

  var suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* A partir de cuantas unidades deja de avisarse. Por encima de esto el aviso
     no dice nada util y empieza a oler a urgencia fabricada. */
  var UMBRAL_POCAS = 5;

  var el = {
    titulo: raiz.querySelector('[data-sx-titulo]'),
    swatches: raiz.querySelector('[data-sx-swatches]'),
    grupoColor: raiz.querySelector('[data-sx-grupo="color"]'),
    models: raiz.querySelector('[data-sx-models]'),
    grupoModel: raiz.querySelector('[data-sx-grupo="model"]'),
    imagenes: raiz.querySelector('[data-sx-imagenes]'),
    thumbs: raiz.querySelector('[data-sx-thumbs]'),
    precio: raiz.querySelector('[data-sx-precio]'),
    antes: raiz.querySelector('[data-sx-antes]'),
    descuento: raiz.querySelector('[data-sx-descuento]'),
    promo: raiz.querySelector('[data-sx-promo]'),
    stock: raiz.querySelector('[data-sx-stock]'),
    quedan: raiz.querySelector('[data-sx-quedan]'),
    add: raiz.querySelector('[data-sx-add]'),
    feedback: raiz.querySelector('[data-sx-feedback]'),
    enlace: raiz.querySelector('[data-sx-enlace]'),
    glow: raiz.querySelector('[data-sx-glow]'),
    valorDesign: raiz.querySelector('[data-sx-valor="design"]'),
    valorColor: raiz.querySelector('[data-sx-valor="color"]'),
    valorModel: raiz.querySelector('[data-sx-valor="model"]'),
    valorBundle: raiz.querySelector('[data-sx-valor="bundle"]'),
    tiers: raiz.querySelector('[data-sx-tiers]'),
    tierNota: raiz.querySelector('[data-sx-tier-note]'),
    ship: raiz.querySelector('[data-sx-ship]'),
    shipTexto: raiz.querySelector('[data-sx-ship-texto]'),
    shipBarra: raiz.querySelector('[data-sx-ship-barra]'),
    mix: raiz.querySelector('[data-sx-mix]'),
    mixToggle: raiz.querySelector('[data-sx-mix-toggle]'),
    mixPanel: raiz.querySelector('[data-sx-mix-panel]'),
    mixSlots: raiz.querySelector('[data-sx-mix-slots]'),
    mixAyuda: raiz.querySelector('[data-sx-mix-ayuda]')
  };

  var raizTienda = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var estado = { design: 0, color: 0, model: 0, foto: 0, tier: 0, mezcla: null, slot: 0 };

  /* El anticipo de la home enlaza aqui con el color ya elegido
     (?color=black-gold). Si llega uno valido, arrancamos en el diseno y el
     color que toquen en vez de en el primero: asi la eleccion no se pierde al
     cambiar de pagina. Si no cuadra con nada, se ignora sin ruido.

     Acepta dos formas porque el color vive en dos sitios segun la pagina: en
     Classic es un valor de la opcion Color, y en Solid es el producto entero.
     Por eso se prueba tambien contra el handle del diseno. */
  (function aplicarColorDeLaUrl() {
    var pedido;
    try {
      pedido = new URLSearchParams(window.location.search).get('color');
    } catch (e) {
      return;
    }
    if (!pedido) return;

    pedido = pedido.toLowerCase();

    for (var d = 0; d < datos.designs.length; d++) {
      var colores = datos.designs[d].colores || [];
      for (var c = 0; c < colores.length; c++) {
        if (colores[c].etiqueta === pedido) {
          estado.design = d;
          estado.color = c;
          return;
        }
      }
    }

    for (var h = 0; h < datos.designs.length; h++) {
      if (String(datos.designs[h].handle).toLowerCase() === pedido) {
        estado.design = h;
        return;
      }
    }
  })();

  function actual() {
    return datos.designs[estado.design];
  }

  /* La tienda cobra en dolares y el formato de los precios lo pone Liquid con
     `money`. Aqui solo hay un numero suelto, asi que se compone igual. */
  function formatearPrecio(n) {
    return '$' + Number(n).toFixed(2);
  }

  /* Los precios de las variantes llegan en centimos, no en unidades como los de
     la promo. Se formatean aparte para no confundir las dos escalas. */
  function formatearCentimos(c) {
    return '$' + (Number(c) / 100).toFixed(2);
  }

  function formatearFecha(iso) {
    var f = new Date(iso + 'T00:00:00');
    if (isNaN(f)) return iso;
    return f.toLocaleDateString('en-GB', { day: 'numeric', month: 'long' });
  }

  /* --- variantes ------------------------------------------------------- */

  /** Valores de modelo de un diseno, en el orden en que aparecen. */
  function modelosDe(d) {
    var i = d.opciones.indexOf('model');
    if (i < 0) return [];
    var vistos = [];
    d.variantes.forEach(function (v) {
      if (v.valores[i] && vistos.indexOf(v.valores[i]) < 0) vistos.push(v.valores[i]);
    });
    return vistos;
  }

  /** La variante que corresponde al color y modelo elegidos. */
  function varianteActual() {
    var d = actual();
    var iColor = d.opciones.indexOf('color');
    var iModel = d.opciones.indexOf('model');
    var color = d.colores[estado.color];
    var modelos = modelosDe(d);
    var modelo = modelos[estado.model];

    return (
      d.variantes.filter(function (v) {
        if (iColor >= 0 && color && v.valores[iColor] !== color.nombre) return false;
        if (iModel >= 0 && modelo && v.valores[iModel] !== modelo) return false;
        return true;
      })[0] || d.variantes[0]
    );
  }

  /** Fotos a mostrar: las del color, si no la de la variante, si no las del producto. */
  function fotosActuales() {
    var d = actual();
    var color = d.colores[estado.color];
    if (color && color.fotos && color.fotos.length) return color.fotos;
    var v = varianteActual();
    if (v && v.foto) return [v.foto];
    return d.respaldo || [];
  }

  /* --- pintado ---------------------------------------------------------- */

  function pintarDesigns() {
    raiz.querySelectorAll('[data-sx-design]').forEach(function (boton) {
      var activo = Number(boton.dataset.sxDesign) === estado.design;
      boton.setAttribute('aria-checked', activo ? 'true' : 'false');
      boton.classList.toggle('is-activo', activo);
    });
    if (el.valorDesign) el.valorDesign.textContent = actual().corto;
  }

  function pintarSwatches() {
    var d = actual();
    el.swatches.innerHTML = '';

    /* No todos los disenos tienen eje de color: en los prints y en los
       colorways lisos el color es el producto entero. Sin esconder el grupo se
       quedaria una etiqueta "Color" sobre una fila vacia. */
    if (el.grupoColor) el.grupoColor.hidden = d.colores.length === 0;

    /* Si el color elegido ya no cabe con el modelo actual, o se quedo sin
       stock, saltar al primero que si. El orden importa: primero se busca uno
       que exista Y este disponible; si no hay, uno que al menos exista, para
       no dejar seleccionado un color que ni siquiera se pinta. */
    if (!colorExisteEnModelo(estado.color) || colorBloqueado(estado.color)) {
      var destino = -1;
      for (var c = 0; c < d.colores.length; c++) {
        if (!colorExisteEnModelo(c)) continue;
        if (!colorBloqueado(c)) { destino = c; break; }
        if (destino < 0) destino = c;
      }
      if (destino >= 0) estado.color = destino;
    }

    d.colores.forEach(function (color, i) {
      /* Combinacion que no existe: no se pinta. No es un color agotado, es un
         color que el proveedor no fabrica para ese modelo, y ensenarlo en gris
         solo invita a intentarlo. El dorado, por ejemplo, solo existe en MG. */
      if (!colorExisteEnModelo(i)) return;

      var bloqueado = colorBloqueado(i);
      var boton = document.createElement('button');
      boton.type = 'button';
      boton.className = 'sx-swatch' + (i === estado.color ? ' is-activo' : '') + (bloqueado ? ' is-agotado' : '');
      boton.setAttribute('role', 'radio');
      boton.setAttribute('aria-checked', i === estado.color ? 'true' : 'false');
      boton.setAttribute('aria-label', color.nombre + (bloqueado ? ' (currently unavailable)' : ''));
      boton.title = color.nombre + (bloqueado ? ' — currently unavailable' : '');
      boton.dataset.sxColor = String(i);
      if (bloqueado) {
        boton.disabled = true;
        boton.setAttribute('aria-disabled', 'true');
      }

      var disco = document.createElement('span');
      disco.className = 'sx-swatch__disco';
      // Dos tonos cuando la correa y el metal se eligen juntos.
      disco.style.background = color.metal
        ? 'linear-gradient(135deg, ' + color.banda + ' 0 52%, ' + color.metal + ' 52% 100%)'
        : color.banda;
      boton.appendChild(disco);

      el.swatches.appendChild(boton);
    });

    if (el.valorColor) el.valorColor.textContent = d.colores[estado.color] ? d.colores[estado.color].nombre : '';
  }

  /* Un color se bloquea cuando no le queda ninguna variante comprable en
     ningun modelo. Hace falta desde que un diseno puede quedarse con parte de
     su gama sin proveedor: sin esto la muestra se ve normal, se elige, y la
     unica pista de que no se puede comprar aparece al lado del precio. */
  function colorBloqueado(indice) {
    var d = actual();
    var iColor = d.opciones.indexOf('color');
    if (iColor < 0) return false;
    var color = d.colores[indice];
    if (!color) return false;
    for (var i = 0; i < d.variantes.length; i++) {
      if (d.variantes[i].valores[iColor] === color.nombre && d.variantes[i].disponible) return false;
    }
    return true;
  }

  /* Distinto de `colorBloqueado`: aquello es "existe pero no se puede comprar",
     esto es "no existe con el modelo elegido". La diferencia se ve: lo primero
     se pinta en gris, lo segundo no se pinta.

     Sin eje de modelo (Solid, Classic) devuelve siempre true y todo sigue como
     estaba. */
  function colorExisteEnModelo(indice) {
    var d = actual();
    var iColor = d.opciones.indexOf('color');
    var iModel = d.opciones.indexOf('model');
    if (iColor < 0 || iModel < 0) return true;

    var color = d.colores[indice];
    if (!color) return false;

    var modelo = modelosDe(d)[estado.model];
    if (!modelo) return true;

    for (var i = 0; i < d.variantes.length; i++) {
      var v = d.variantes[i];
      if (v.valores[iColor] === color.nombre && v.valores[iModel] === modelo) return true;
    }
    return false;
  }

  /* Un modelo se bloquea por dos vias: porque no le quede ninguna variante
     comprable, o porque este escrito a mano en los ajustes. La segunda existe
     porque Shopify puede decir que hay stock cuando en el almacen no lo hay,
     y ahi el dato no sirve de guia. */
  function modeloBloqueado(nombre) {
    var manual = (el.models.getAttribute('data-no-disponibles') || '').split(',');
    for (var i = 0; i < manual.length; i++) {
      var etiqueta = manual[i].trim().toLowerCase();
      if (etiqueta && etiqueta === nombre.toLowerCase()) return true;
    }
    var d = actual();
    var iModel = d.opciones.indexOf('model');
    if (iModel < 0) return false;
    for (var j = 0; j < d.variantes.length; j++) {
      if (d.variantes[j].valores[iModel] === nombre && d.variantes[j].disponible) return false;
    }
    return true;
  }

  /* Familias de montura, leidas del marcado como "prefijo|etiqueta" separadas
     por comas. Sirven para partir la lista: las ocho monturas de un colorway
     son cuatro de Whoop 5 y cuatro de MG, y de corrido no se distinguen. */
  function familiasDeMontura() {
    var crudo = (el.models.getAttribute('data-familias') || '').split(',');
    var salida = [];
    crudo.forEach(function (trozo) {
      var partes = trozo.split('|');
      var prefijo = (partes[0] || '').trim();
      if (!prefijo) return;
      salida.push({ prefijo: prefijo.toLowerCase(), etiqueta: (partes[1] || prefijo).trim() });
    });
    return salida;
  }

  /** Familia a la que pertenece un modelo, o null si no encaja en ninguna. */
  function familiaDe(nombre, familias) {
    var min = String(nombre).toLowerCase();
    for (var i = 0; i < familias.length; i++) {
      if (min.indexOf(familias[i].prefijo) === 0) return familias[i];
    }
    return null;
  }

  function pintarModelos() {
    var modelos = modelosDe(actual());

    if (modelos.length < 2) {
      el.grupoModel.hidden = true;
      el.models.innerHTML = '';
      return;
    }

    el.grupoModel.hidden = false;
    el.models.innerHTML = '';

    // Si el modelo elegido acaba de quedarse bloqueado, saltar al primero que no lo este.
    if (modeloBloqueado(modelos[estado.model])) {
      for (var k = 0; k < modelos.length; k++) {
        if (!modeloBloqueado(modelos[k])) { estado.model = k; break; }
      }
    }

    /* Solo se parte si de verdad hay mas de una familia en juego. Who Cares
       tiene dos monturas con otro patron de nombre y se queda de corrido. */
    var familias = familiasDeMontura();
    var cuentaPorFamilia = {};
    modelos.forEach(function (nombre) {
      var f = familiaDe(nombre, familias);
      if (!f) return;
      cuentaPorFamilia[f.etiqueta] = (cuentaPorFamilia[f.etiqueta] || 0) + 1;
    });
    var vistas = Object.keys(cuentaPorFamilia);

    /* Se parte en familias solo si alguna agrupa de verdad a mas de un modelo.
       En las de nylon el Frame lleva ademas el acabado (Whoop 5 Black, Whoop 5
       Gold...) y el titular ayuda. En las de piel hay un valor por familia, y
       partir dejaba un titular "WHOOP 5.0" encima de un unico boton que ponia
       "Whoop 5": el mismo dato escrito dos veces y peor la segunda. */
    var partir = vistas.length > 1 && vistas.some(function (e) { return cuentaPorFamilia[e] > 1; });
    var familiaAnterior = null;

    /* Sin titulares de familia, el boton carga con el nombre completo: mejor
       "WHOOP 5.0" que el "Whoop 5" con el que viene la opcion de Shopify. Se
       usa la etiqueta de la familia solo cuando esa familia es este unico
       modelo, para no llamar igual a dos botones distintos.

       Lo usan el boton Y el rotulo del grupo. Estaban calculando el nombre por
       separado y el rotulo se quedo diciendo "Whoop 5" al lado de un boton que
       ya decia "WHOOP 5.0". */
    function nombreVisible(nombre) {
      var f = familiaDe(nombre, familias);
      return !partir && f && cuentaPorFamilia[f.etiqueta] === 1 ? f.etiqueta : nombre;
    }

    /* Texto del boton. Cuando hay titulares de familia el prefijo sobra: la
       seccion ya dice WHOOP 5.0 o MG, y "Black / Silver / Gold / Rose Gold"
       cabe en una fila donde "Whoop 5 Rose Gold" necesitaba dos.
       Solo afecta al boton: el resumen del grupo y la etiqueta accesible
       siguen con el nombre entero, que fuera de contexto si hace falta. */
    function nombreCorto(nombre) {
      if (!partir) return nombreVisible(nombre);
      var f = familiaDe(nombre, familias);
      if (!f) return nombre;
      var corto = String(nombre).slice(f.prefijo.length).trim();
      return corto || nombre;
    }

    modelos.forEach(function (nombre, i) {
      if (partir) {
        var f = familiaDe(nombre, familias);
        var etiqueta = f ? f.etiqueta : null;
        if (etiqueta && etiqueta !== familiaAnterior) {
          /* El separador ocupa toda la fila, asi que fuerza el salto en el
             contenedor flexible sin sacar los botones del radiogroup. */
          var sep = document.createElement('span');
          sep.className = 'sx-model-sep';
          sep.setAttribute('role', 'presentation');
          sep.textContent = etiqueta;
          el.models.appendChild(sep);
        }
        familiaAnterior = etiqueta;
      }

      var bloqueado = modeloBloqueado(nombre);
      var boton = document.createElement('button');
      boton.type = 'button';
      boton.className = 'sx-model' + (i === estado.model ? ' is-activo' : '') + (bloqueado ? ' is-agotado' : '');
      boton.setAttribute('role', 'radio');
      boton.setAttribute('aria-checked', i === estado.model ? 'true' : 'false');
      boton.dataset.sxModel = String(i);
      boton.textContent = nombreCorto(nombre);
      boton.setAttribute('aria-label', nombreVisible(nombre));
      if (bloqueado) {
        boton.disabled = true;
        boton.setAttribute('aria-disabled', 'true');
        boton.title = 'Currently unavailable';
      }
      el.models.appendChild(boton);
    });

    if (el.valorModel) el.valorModel.textContent = modelos[estado.model] ? nombreVisible(modelos[estado.model]) : '';
  }

  /** Cambia la foto grande con un fundido, sin quitar la anterior de golpe. */
  function pintarImagen() {
    /* En la ficha de producto este panel se monta sin visor: la galeria la pinta
       el tema. Sin esta salida, el panel entero se caia al arrancar. */
    if (!el.imagenes) return;

    var fotos = fotosActuales();
    var url = fotos[estado.foto] || fotos[0];
    if (!url) return;

    var previa = el.imagenes.querySelector('.sx-foto.is-activa');
    if (previa && previa.dataset.url === url) return;

    var img = document.createElement('img');
    img.className = 'sx-foto';
    img.dataset.url = url;
    img.src = url;
    img.alt = actual().title + ' — ' + (actual().colores[estado.color] || {}).nombre;
    img.loading = 'eager';
    img.decoding = 'async';

    el.imagenes.appendChild(img);

    var mostrar = function () {
      // Reflow forzado en vez de requestAnimationFrame: rAF no se ejecuta
      // mientras la pestana no pinta fotogramas (segundo plano), y entonces la
      // foto se quedaba invisible para siempre. Esto es sincrono y basta para
      // que la transicion arranque desde el estado inicial.
      void img.offsetWidth;
      img.classList.add('is-activa');

      if (!previa) return;
      previa.classList.remove('is-activa');
      if (suave) {
        window.setTimeout(function () {
          if (previa.parentNode) previa.parentNode.removeChild(previa);
        }, 460);
      } else if (previa.parentNode) {
        previa.parentNode.removeChild(previa);
      }
    };

    if (img.complete) {
      mostrar();
    } else {
      img.addEventListener('load', mostrar, { once: true });
      img.addEventListener('error', mostrar, { once: true });
    }

    // El halo de fondo toma el color de la correa: da sensacion de material.
    var color = actual().colores[estado.color];
    if (el.glow && color) el.glow.style.setProperty('--sx-glow', color.banda);
  }

  function pintarThumbs() {
    if (!el.thumbs) return;
    var fotos = fotosActuales();

    /* En movil la zona fijada ensena dos vistas grandes, no una tira de
       miniaturas: con cuatro se parten en dos filas y cada una queda diminuta.
       Se muestran las dos primeras, que son las del producto montado. */
    if (window.matchMedia('(max-width: 989px)').matches) fotos = fotos.slice(0, 2);

    el.thumbs.innerHTML = '';

    /* Con una sola foto no hay miniaturas que pintar. Se marca el visor para
       que la maquetacion lo sepa: en movil la zona fijada muestra las dos
       vistas y sin este aviso se quedaria en blanco. */
    var visor = el.thumbs.closest('.sx-viewer');
    if (visor) {
      /* Cambiar de colorway es un cambio de contenido, no de estado de scroll:
         tiene que ser instantaneo. Sin esto, al pasar de un colorway con dos
         fotos a uno con una, la imagen entraba con la animacion del pliegue
         —medio segundo escalando— mientras las miniaturas desaparecian de
         golpe, y se veia como un parpadeo. */
      visor.classList.add('sx-sin-animacion');
      visor.classList.toggle('sx-viewer--una-foto', fotos.length < 2);
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          visor.classList.remove('sx-sin-animacion');
        });
      });
    }

    if (fotos.length < 2) return;

    fotos.forEach(function (url, i) {
      var boton = document.createElement('button');
      boton.type = 'button';
      boton.className = 'sx-thumb' + (i === estado.foto ? ' is-activo' : '');
      boton.setAttribute('role', 'tab');
      boton.setAttribute('aria-selected', i === estado.foto ? 'true' : 'false');
      boton.setAttribute('aria-label', 'View ' + (i + 1));
      boton.dataset.sxFoto = String(i);

      var img = document.createElement('img');
      img.src = url;
      img.alt = '';
      img.loading = 'lazy';
      boton.appendChild(img);

      el.thumbs.appendChild(boton);
    });
  }

  function pintarCompra() {
    var v = varianteActual();
    var d = actual();

    if (el.titulo) el.titulo.textContent = d.title;
    if (el.enlace) el.enlace.href = d.url;

    var cantidad = tramoActual().cant;

    /* Con una unidad se respeta el texto que compuso Liquid con `money`; a partir
       de dos hay que multiplicar, y el importe se compone aqui. */
    if (v && el.precio) {
      /* El precio que se ensena es el que se cobra: antes se mostraba el bruto
         del pack y el descuento se explicaba en una nota debajo, que obligaba a
         hacer la cuenta para saber cuanto ibas a pagar. */
      var textoPrecio = cantidad === 1
        ? v.precio_texto
        : formatearCentimos(Math.round((precioDelPack(v) * (100 - tramoActual().pct)) / 100));
      if (el.precio.textContent !== textoPrecio) {
        el.precio.textContent = textoPrecio;
        if (suave) {
          el.precio.classList.remove('is-cambiado');
          void el.precio.offsetWidth; // reflow para poder repetir la animacion
          el.precio.classList.add('is-cambiado');
        }
      }
    }

    /* Precio tachado y porcentaje. Se ocultan si esta variante no esta rebajada:
       no todas tienen por que estarlo.

       El tachado escala con la cantidad igual que el precio, asi que el porcentaje
       no cambia. Ahi solo vive la rebaja de tarifa; el descuento por cantidad no
       entra nunca en esta comparacion. */
    if (el.antes) {
      var hayRebaja = v && v.antes_texto;
      el.antes.hidden = !hayRebaja;
      el.antes.textContent = !hayRebaja
        ? ''
        : cantidad === 1 ? v.antes_texto : formatearCentimos(v.antes * cantidad);
    }
    if (el.descuento) {
      var pct = v && v.descuento ? v.descuento : 0;
      el.descuento.hidden = pct <= 0;
      el.descuento.textContent = pct > 0 ? '-' + pct + '%' : '';
    }

    /* Promocion del diseno. Se anuncia como descuento aplicado, no como precio
       anterior: "pagas X en el checkout". Si algun dia se convierte esto en un
       tachado, hay que comprobar antes la regla de los 30 dias. */
    if (el.promo) {
      var promo = d.promo;
      el.promo.hidden = !promo;
      if (promo) {
        var texto = promo.texto + ' — you pay ' + formatearPrecio(promo.pagas) + ' at checkout';
        if (promo.hasta) texto += ', until ' + formatearFecha(promo.hasta);
        el.promo.textContent = texto;
      }
    }

    var disponible = v && v.disponible;
    el.add.disabled = !disponible;
    el.add.classList.toggle('is-agotado', !disponible);
    el.add.querySelector('.sx-add__label').textContent = disponible
      ? cantidad > 1 ? 'Add ' + cantidad + ' to cart' : 'Add to cart'
      : 'Sold out';
    /* El texto sale de los ajustes: es una afirmacion sobre plazos y quien la
       hace tiene que poder corregirla sin tocar este fichero. */
    if (el.stock) {
      el.stock.textContent = disponible
        ? el.stock.getAttribute('data-disponible') || 'In stock'
        : el.stock.getAttribute('data-agotado') || 'Currently unavailable';
    }

    /* Unidades restantes. Solo cuando Shopify sigue el inventario de esa
       variante (`quedan` distinto de null) y quedan pocas. El numero es el
       stock real: si no hay dato, no se pinta nada, porque un "quedan 3"
       inventado es una afirmacion falsa, no un recurso de venta. */
    if (el.quedan) {
      var restan = v && typeof v.quedan === 'number' ? v.quedan : null;
      var avisar = disponible && restan !== null && restan > 0 && restan <= UMBRAL_POCAS;
      el.quedan.hidden = !avisar;
      if (avisar) {
        /* Sin cifra. El numero exacto envejece en cuanto entra un pedido y
           obliga a que la pagina lo persiga; "pocas" sigue siendo cierto todo
           el tramo. La condicion para ensenarlo sigue siendo el stock real:
           por debajo de UMBRAL_POCAS y con inventario seguido. */
        el.quedan.textContent = 'Only a few left';
      }
    }

    avisarGaleria(v);
  }

  /* --- la galeria del tema ----------------------------------------------
     En la ficha de producto la galeria no es la de este configurador, sino la
     `<media-gallery>` de Horizon, y por eso cambiar de color no movia la foto:
     nadie le decia que la variante habia cambiado.

     Esa galeria escucha `shopify:product:select` en su `.shopify-section` y no
     espera datos en el evento, sino una promesa colgada de el que resuelva con
     el HTML de la seccion ya renderizada para la variante. Se queda con el
     <media-gallery> de dentro y se reemplaza con el. Asi que hay que pedirle a
     Shopify la seccion con `?variant=…&section_id=…` y lanzarle el evento.

     En las paginas que usan la galeria propia del configurador no hay ningun
     `media-gallery` y esto no hace nada. */

  var EVENTO_VARIANTE = 'shopify:product:select';
  var varianteAvisada = null;

  function avisarGaleria(v) {
    if (!v || !v.id) return;

    var galeria = document.querySelector('media-gallery');
    if (!galeria) return;

    var seccion = galeria.closest('.shopify-section');
    if (!seccion || !seccion.id) return;

    // La primera pasada es el pintado inicial: la galeria ya viene con la
    // variante correcta del servidor y pedirla otra vez seria una peticion
    // tirada a la basura.
    if (varianteAvisada === null) {
      varianteAvisada = v.id;
      return;
    }
    if (varianteAvisada === v.id) return;
    varianteAvisada = v.id;

    var url =
      window.location.pathname +
      '?variant=' + encodeURIComponent(v.id) +
      '&section_id=' + encodeURIComponent(seccion.id.replace(/^shopify-section-/, ''));

    var evento = new CustomEvent(EVENTO_VARIANTE, { bubbles: true });
    evento.promise = fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (texto) {
        return { detail: { html: new DOMParser().parseFromString(texto, 'text/html') } };
      });

    // Si la peticion falla no pasa nada: la galeria se queda como estaba y el
    // resto de la ficha (precio, stock, carrito) sigue funcionando.
    evento.promise.catch(function () {});

    seccion.dispatchEvent(evento);
  }

  /* --- escalado por cantidad -------------------------------------------- */

  /** Cantidad y descuento del tramo elegido. Sin tramos, una unidad y sin descuento. */
  function tramoActual() {
    var botones = el.tiers ? el.tiers.querySelectorAll('[data-sx-tier]') : [];
    var boton = botones[estado.tier];
    if (!boton) return { cant: 1, pct: 0 };
    return { cant: Number(boton.getAttribute('data-sx-cant')) || 1, pct: Number(boton.getAttribute('data-sx-pct')) || 0 };
  }

  function pintarTiers() {
    if (!el.tiers) return;

    var v = varianteActual();
    var unidad = v && v.precio ? v.precio : 0;
    var botones = el.tiers.querySelectorAll('[data-sx-tier]');

    Array.prototype.forEach.call(botones, function (boton, i) {
      var activo = i === estado.tier;
      boton.classList.toggle('is-activo', activo);
      boton.setAttribute('aria-checked', activo ? 'true' : 'false');
      boton.tabIndex = activo ? 0 : -1;

      var pct = Number(boton.getAttribute('data-sx-pct')) || 0;
      var cada = boton.querySelector('[data-sx-tier-each]');
      if (cada) cada.textContent = unidad ? formatearCentimos(Math.round((unidad * (100 - pct)) / 100)) + ' each' : '';
    });

    var tramo = tramoActual();
    if (el.valorBundle) el.valorBundle.textContent = tramo.cant + (tramo.cant === 1 ? ' band' : ' bands');

    /* Sin nota de ahorro: el precio de arriba ya es el que se paga, asi que
       repetirlo debajo solo anadia una cuenta que hacer. */
    if (el.tierNota) {
      el.tierNota.hidden = true;
      el.tierNota.textContent = '';
    }
  }

  /* --- envio gratis ------------------------------------------------------ */

  function pintarEnvio(carrito) {
    if (!el.ship) return;

    var umbral = (Number(el.ship.getAttribute('data-umbral')) || 0) * 100;
    var total = carrito && typeof carrito.total_price === 'number' ? carrito.total_price : 0;

    // Con el carrito vacio la barra no aporta nada: solo mete ruido antes de elegir.
    if (umbral <= 0 || total <= 0) {
      el.ship.hidden = true;
      return;
    }

    el.ship.hidden = false;
    var logrado = total >= umbral;
    el.ship.classList.toggle('is-logrado', logrado);
    if (el.shipBarra) el.shipBarra.style.width = Math.min(100, (total / umbral) * 100).toFixed(1) + '%';
    if (el.shipTexto) {
      el.shipTexto.textContent = logrado
        ? el.ship.getAttribute('data-logrado') || 'Free shipping unlocked'
        : (el.ship.getAttribute('data-falta') || 'You are [resto] away from free shipping').replace(
            '[resto]',
            formatearCentimos(umbral - total)
          );
    }
  }

  function refrescarEnvio() {
    if (!el.ship) return;
    fetch(raizTienda + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (respuesta) { return respuesta.json(); })
      .then(pintarEnvio)
      .catch(function () { /* sin carrito no hay barra, y no es un error que mostrar */ });
  }

  // Cualquier alta en el carrito, venga de donde venga, mueve la barra.
  document.addEventListener('shopify:cart:lines-update', refrescarEnvio);

  /* --- mezcla de colorways ----------------------------------------------
     Un pack de 2 o 3 puede llevar colorways distintos. El eje que define el
     colorway cambia segun la pagina: en Solid cada colorway es un design
     entero, y en Classic es un valor de la opcion Color del mismo design.
     Todo lo demas (el frame, el precio, el tramo) es comun a todo el pack. */

  function ejeMezcla() {
    return actual().colores.length > 0 ? 'color' : 'design';
  }

  function nombreDeOpcion(indice) {
    if (ejeMezcla() === 'color') {
      var c = actual().colores[indice];
      return c ? c.nombre : '';
    }
    var d = datos.designs[indice];
    return d ? d.corto : '';
  }

  /* El disco de color ya esta pintado en la paleta, asi que se reutiliza en
     vez de recalcularlo: en Solid vive en el Liquid y aqui no llega. */
  function fondoDeOpcion(indice) {
    var sel = ejeMezcla() === 'color'
      ? '[data-sx-color="' + indice + '"] .sx-swatch__disco'
      : '[data-sx-design="' + indice + '"] .sx-swatch__disco';
    var disco = raiz.querySelector(sel);
    return disco ? disco.style.background : '';
  }

  /** Variante de un colorway con el frame elegido ahora. null si no existe. */
  function varianteDeMezcla(indice) {
    var modelo = modelosDe(actual())[estado.model];
    var porColor = ejeMezcla() === 'color';
    var d = porColor ? actual() : datos.designs[indice];
    if (!d) return null;

    var iColor = d.opciones.indexOf('color');
    var iModel = d.opciones.indexOf('model');
    var nombreColor = porColor && d.colores[indice] ? d.colores[indice].nombre : null;

    return d.variantes.filter(function (v) {
      if (iColor >= 0 && nombreColor && v.valores[iColor] !== nombreColor) return false;
      if (iModel >= 0 && modelo && v.valores[iModel] !== modelo) return false;
      return true;
    })[0] || null;
  }

  /* Un color por hueco: con dos o tres bandas en juego, el numero solo no
     basta para saber de un vistazo cual es cual en la paleta. */
  var COLORES_HUECO = ['var(--s-acid)', '#4cc9ff', '#ff7ac4'];

  function colorDeHueco(i) {
    return COLORES_HUECO[i % COLORES_HUECO.length];
  }

  /** Frames que existen para un colorway, por nombre. */
  function framesDe(indice) {
    var d = ejeMezcla() === 'color' ? actual() : datos.designs[indice];
    return d ? modelosDe(d) : [];
  }

  /** Variante de un colorway con un frame concreto. */
  function varianteDe(indice, frame) {
    var porColor = ejeMezcla() === 'color';
    var d = porColor ? actual() : datos.designs[indice];
    if (!d) return null;

    var iColor = d.opciones.indexOf('color');
    var iModel = d.opciones.indexOf('model');
    var nombreColor = porColor && d.colores[indice] ? d.colores[indice].nombre : null;

    return d.variantes.filter(function (v) {
      if (iColor >= 0 && nombreColor && v.valores[iColor] !== nombreColor) return false;
      if (iModel >= 0 && frame && v.valores[iModel] !== frame) return false;
      return true;
    })[0] || null;
  }

  /** Un colorway se puede comprar si le queda alguna montura con stock. */
  function colorwayComprable(indice) {
    var lista = framesDe(indice);
    for (var i = 0; i < lista.length; i++) {
      var v = varianteDe(indice, lista[i]);
      if (v && v.disponible) return true;
    }
    return false;
  }

  /** Primera montura disponible para TODOS los colorways dados. */
  function frameComun(indices, preferido) {
    var candidatos = framesDe(indices[0]).slice();
    if (preferido) candidatos.unshift(preferido);

    for (var i = 0; i < candidatos.length; i++) {
      var sirve = true;
      for (var j = 0; j < indices.length; j++) {
        var v = varianteDe(indices[j], candidatos[i]);
        if (!v || !v.disponible) { sirve = false; break; }
      }
      if (sirve) return candidatos[i];
    }
    return null;
  }

  function mezclaActiva() {
    return !!estado.mezcla && tramoActual().cant > 1;
  }

  /** Ajusta los huecos al tamano del pack conservando lo ya elegido. */
  function ajustarMezcla() {
    var n = tramoActual().cant;
    while (estado.mezcla.length > n) estado.mezcla.pop();
    while (estado.mezcla.length < n) estado.mezcla.push(null);
    if (estado.slot >= n) estado.slot = n - 1;
  }

  function alternarMezcla() {
    if (estado.mezcla) {
      estado.mezcla = null;
    } else {
      /* El primer hueco arranca con lo que ya estaba elegido: cambiar de idea
         no deberia costar volver a elegir lo que ya tenias. */
      estado.mezcla = [ejeMezcla() === 'color' ? estado.color : estado.design];
      ajustarMezcla();
      var libre = estado.mezcla.indexOf(null);
      estado.slot = libre >= 0 ? libre : 0;
    }
    limpiarAviso();
    pintarTodo();
  }

  /* Mueve la vista previa (foto, titulo, precio) al colorway indicado sin
     tocar la composicion del pack. El frame se conserva por nombre y no por
     posicion: los colorways de 6 frames desplazarian el indice. */
  function verColorway(indice) {
    if (ejeMezcla() === 'color') {
      estado.color = indice;
      estado.foto = 0;
      return;
    }

    var frame = modelosDe(actual())[estado.model];
    estado.design = indice;
    var nuevos = modelosDe(actual());
    var i = nuevos.indexOf(frame);
    estado.model = i >= 0 ? i : 0;
    estado.foto = 0;
  }

  /** Precio del pack: cada hueco con el suyo. Los que aun falten cuentan como
      el colorway que se esta viendo, para que el importe no baile al elegir. */
  function precioDelPack(v) {
    var n = tramoActual().cant;
    var suelto = v && v.precio ? v.precio : 0;
    if (!mezclaActiva()) return suelto * n;

    var total = 0;
    for (var i = 0; i < n; i++) {
      var indice = estado.mezcla[i];
      if (indice === null || indice === undefined) { total += suelto; continue; }
      var variante = varianteDeMezcla(indice);
      total += variante ? variante.precio : suelto;
    }
    return total;
  }

  function elegirEnHueco(indice) {
    if (!colorwayComprable(indice)) {
      avisar(nombreDeOpcion(indice) + ' is out of stock in every frame.', 'error');
      return;
    }

    var previo = estado.mezcla[estado.slot];
    estado.mezcla[estado.slot] = indice;

    /* Todas las bandas comparten montura, asi que hay que encontrar una que
       sirva para las elegidas hasta ahora. Se prefiere la puesta; si no vale,
       se cambia sola y se avisa, que es mejor que tachar el color. */
    var elegidos = estado.mezcla.filter(function (x) { return x !== null; });
    var frameAhora = modelosDe(actual())[estado.model];
    var comun = frameComun(elegidos, frameAhora);

    if (!comun) {
      estado.mezcla[estado.slot] = previo;
      avisar(nombreDeOpcion(indice) + ' shares no frame with the rest of the pack.', 'error');
      return;
    }

    var cambiaFrame = comun !== frameAhora;

    // Saltar al siguiente hueco sin elegir, si queda alguno.
    var siguiente = estado.mezcla.indexOf(null);
    if (siguiente >= 0) estado.slot = siguiente;

    verColorway(indice);

    var lista = modelosDe(actual());
    var im = lista.indexOf(comun);
    estado.model = im >= 0 ? im : 0;

    limpiarAviso();
    pintarTodo();

    if (cambiaFrame) {
      avisar('Frame switched to ' + comun + ' — the one available for every band.', 'ok');
    }
  }

  /** Marca en la paleta lo que ya esta en el pack y lo que no encaja. */
  function pintarPaletaMezcla(activa) {
    var sel = ejeMezcla() === 'color' ? '[data-sx-color]' : '[data-sx-design]';
    var botones = raiz.querySelectorAll(sel);

    Array.prototype.forEach.call(botones, function (boton) {
      var crudo = boton.dataset.sxColor !== undefined ? boton.dataset.sxColor : boton.dataset.sxDesign;
      var indice = Number(crudo);
      boton.classList.remove('is-en-pack');
      boton.classList.remove('is-fuera-de-pack');
      boton.style.removeProperty('--sx-pack');
      var vieja = boton.querySelector('.sx-swatch__pack');
      if (vieja) vieja.remove();
      if (!activa) return;

      /* Mientras se compone el pack, el aro normal sobra: marcaba el colorway
         "actual", que no tiene por que estar en el pack, y se leia como una
         tercera banda elegida. */
      boton.classList.remove('is-activo');

      /* Se bloquea solo lo que no tiene ninguna montura con stock. Antes se
         miraba la montura elegida en ese momento, y eso tachaba colorways que
         si se podian comprar cambiando de montura. */
      if (!colorwayComprable(indice)) {
        boton.classList.add('is-fuera-de-pack');
        return;
      }

      var huecos = [];
      estado.mezcla.forEach(function (elegido, i) {
        if (elegido === indice) huecos.push(i + 1);
      });
      if (huecos.length) {
        boton.classList.add('is-en-pack');
        boton.style.setProperty('--sx-pack', colorDeHueco(huecos[0] - 1));
        var insignia = document.createElement('span');
        insignia.className = 'sx-swatch__pack';
        insignia.textContent = huecos.join(',');
        boton.appendChild(insignia);
      }
    });
  }

  /* En movil los circulos de banda quedaban bajo el selector de packs, muy por
     debajo de la paleta: cambiar una banda ya elegida obligaba a bajar, tocar
     su circulo y volver a subir a por el color. Se mudan a la zona fijada, que
     esta siempre en pantalla. En escritorio se quedan donde estaban. */
  var padreHuecos = null;

  function reubicarHuecos() {
    if (!el.mixSlots) return;
    if (!padreHuecos) padreHuecos = el.mixSlots.parentNode;

    var visor = raiz.querySelector('.sx-viewer');
    var enMovil = window.matchMedia('(max-width: 989px)').matches;
    var destino = (enMovil && visor && mezclaActiva()) ? visor : padreHuecos;

    if (el.mixSlots.parentNode !== destino) destino.appendChild(el.mixSlots);
    // El texto acompana a los circulos: explica lo que se esta componiendo.
    if (el.mixAyuda && el.mixAyuda.parentNode !== destino) destino.appendChild(el.mixAyuda);
  }

  /* Al activar la mezcla —o al cambiar de banda— lo siguiente que se hace es
     elegir color, asi que se lleva la paleta justo debajo de la zona fijada.
     Solo en movil: en escritorio la paleta ya esta a la vista y moverla seria
     desconcertante. Si ya se ve bien colocada, no se toca el scroll. */
  /* El tema trae un cajon de carrito —`theme-drawer#cart-drawer`, que la
     cabecera abre con `#cart-drawer/toggle`— pero este boton hacia su propio
     `fetch` y no se lo decia a nadie: la correa entraba en el carrito y en
     pantalla no pasaba absolutamente nada. Sin cajon, sin aviso y sin ningun
     enlace a la caja, solo seguia comprando quien adivinaba por su cuenta que
     habia que tocar el icono de la bolsa.

     Se llama DESPUES de reemplazar la seccion del cajon, porque ese reemplazo
     sustituye el nodo y una referencia anterior apuntaria al elemento viejo. */
  function abrirCajon() {
    var cajon = document.querySelector('theme-drawer#cart-drawer');
    if (!cajon) return false;

    if (typeof cajon.open === 'function') {
      cajon.open();
      return true;
    }

    /* Si el componente aun no se ha hidratado, se cae al disparador de la
       cabecera, que hace exactamente lo mismo por la via declarativa. */
    var disparador = document.querySelector('[on\:click="#cart-drawer/toggle"]');
    if (disparador) {
      disparador.click();
      return true;
    }

    return false;
  }

  function irALaPaleta() {
    if (!window.matchMedia('(max-width: 989px)').matches) return;

    var paleta = raiz.querySelector('[data-sx-grupo="design"]') ||
                 raiz.querySelector('[data-sx-grupo="color"]');
    if (!paleta) return;

    var visor = raiz.querySelector('.sx-viewer');
    var tope = 70 + (visor ? visor.offsetHeight : 0) + 12;
    var r = paleta.getBoundingClientRect();

    if (r.top >= tope - 8 && r.top <= tope + 120) return;

    var destino = Math.max(0, r.top + window.scrollY - tope);
    var suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Safari no acepto `scrollTo` con objeto hasta la 15.4: en versiones
       anteriores la llamada se ignora entera y el desplazamiento no ocurre.
       Por eso se comprueba antes si el navegador entiende la forma moderna, y
       si no, se usa la de toda la vida, que salta sin animacion pero llega. */
    if ('scrollBehavior' in document.documentElement.style) {
      window.scrollTo({ top: destino, behavior: suave ? 'smooth' : 'auto' });
    } else {
      window.scrollTo(0, destino);
    }
  }

  function pintarMix() {
    if (!el.mix) return;

    var cant = tramoActual().cant;
    // Sin pack no hay nada que mezclar: se apaga y se recoge.
    if (cant < 2 && estado.mezcla) estado.mezcla = null;
    el.mix.hidden = cant < 2;

    /* El boton se lee como una opcion del pack elegido, asi que vive pegado a
       el dentro de la lista, no colgando debajo de los tres. */
    if (el.tiers && cant >= 2) {
      var elegido = el.tiers.querySelectorAll('[data-sx-tier]')[estado.tier];
      if (elegido && el.mix.previousElementSibling !== elegido) {
        el.tiers.insertBefore(el.mix, elegido.nextSibling);
      }
    }

    var activa = mezclaActiva();
    if (el.mixToggle) {
      el.mixToggle.classList.toggle('is-activo', activa);
      el.mixToggle.setAttribute('aria-expanded', activa ? 'true' : 'false');
    }
    if (el.mixPanel) el.mixPanel.hidden = !activa;

    /* Al apagar la mezcla hay que vaciar y devolver los circulos ANTES de
       salir: viven fuera del panel que se oculta —los mudamos a la zona
       fijada—, asi que ocultarlo ya no los tapa. */
    if (!activa) {
      if (el.mixSlots) el.mixSlots.innerHTML = '';
      if (el.mixAyuda) el.mixAyuda.textContent = '';
      reubicarHuecos();
    }

    /* Primero se ajusta el pack y luego se pinta: al reves, al bajar de trio a
       duo la tercera eleccion seguia marcada en la paleta. */
    if (activa) {
      ajustarMezcla();

      /* Cambiar de frame puede dejar sin sentido un colorway ya elegido: se
         vacia su hueco en vez de mandar al carrito algo que no existe. */
      estado.mezcla = estado.mezcla.map(function (indice) {
        if (indice === null) return null;
        var v = varianteDeMezcla(indice);
        return v && v.disponible ? indice : null;
      });
      if (estado.mezcla[estado.slot] !== null) {
        var libre = estado.mezcla.indexOf(null);
        if (libre >= 0) estado.slot = libre;
      }
    }

    pintarPaletaMezcla(activa);
    if (!activa) return;

    if (el.mixSlots) {
      el.mixSlots.innerHTML = '';
      estado.mezcla.forEach(function (indice, i) {
        var vacio = indice === null;
        var boton = document.createElement('button');
        boton.type = 'button';
        boton.className = 'sx-mix__slot' + (i === estado.slot ? ' is-activo' : '') + (vacio ? ' is-vacio' : '');
        boton.dataset.sxMixSlot = String(i);
        boton.style.setProperty('--sx-pack', colorDeHueco(i));
        boton.setAttribute(
          'aria-label',
          'Band ' + (i + 1) + (vacio ? ' — no colorway chosen yet' : ': ' + nombreDeOpcion(indice))
        );
        boton.title = boton.getAttribute('aria-label');

        var disco = document.createElement('span');
        disco.className = 'sx-mix__disco';
        if (!vacio) disco.style.background = fondoDeOpcion(indice);
        boton.appendChild(disco);

        var num = document.createElement('span');
        num.className = 'sx-mix__num';
        num.textContent = String(i + 1);
        boton.appendChild(num);

        el.mixSlots.appendChild(boton);
      });
    }

    reubicarHuecos();

    if (el.mixAyuda) {
      /* El texto abre con el nombre del pack: junto a los circulos, fuera del
         selector de cantidad, hace falta recordar cuantas bandas se estan
         componiendo. */
      var botonTramo = el.tiers ? el.tiers.querySelectorAll('[data-sx-tier]')[estado.tier] : null;
      var etiquetaTramo = botonTramo && botonTramo.querySelector('.sx-tier__name')
        ? botonTramo.querySelector('.sx-tier__name').textContent.trim()
        : '';

      var faltan = estado.mezcla.filter(function (x) { return x === null; }).length;
      var detalle = faltan
        ? 'select a colorway for band ' + (estado.slot + 1)
        : estado.mezcla.map(nombreDeOpcion).join(' + ');

      el.mixAyuda.textContent = etiquetaTramo ? etiquetaTramo + ' — ' + detalle : detalle;
    }
  }

  /** Lineas que van al carrito: una por colorway cuando hay mezcla. */
  function lineasDelPack(v) {
    if (!mezclaActiva()) return [{ id: v.id, quantity: tramoActual().cant }];

    var cuenta = {};
    var orden = [];
    estado.mezcla.forEach(function (indice) {
      var variante = varianteDeMezcla(indice);
      if (!variante) return;
      if (!cuenta[variante.id]) { cuenta[variante.id] = 0; orden.push(variante.id); }
      cuenta[variante.id] += 1;
    });

    return orden.map(function (id) {
      return { id: Number(id), quantity: cuenta[id] };
    });
  }

  /** Motivo por el que el pack mezclado aun no se puede anadir, o null. */
  function problemaMezcla() {
    if (!mezclaActiva()) return null;
    if (estado.mezcla.indexOf(null) >= 0) return 'Pick a colorway for every band in the pack.';

    for (var i = 0; i < estado.mezcla.length; i++) {
      var v = varianteDeMezcla(estado.mezcla[i]);
      if (!v || !v.disponible) {
        return nombreDeOpcion(estado.mezcla[i]) + ' is not available in that frame.';
      }
    }
    return null;
  }

  /* --- Aviso de vista a la analitica -------------------------------------
     El configurador vive en paginas de coleccion, y el pixel de Shopify solo
     dispara `product_viewed` en fichas de producto. Resultado medido en Meta:
     88 "Ver contenido" contra 85 "Anadir al carrito" —el 96%, imposible— y el
     publico de retargeting "miro y no compro" se quedaba en 88 personas
     cuando de verdad son cientos.

     Se publica un evento propio que el pixel personalizado traduce a
     ViewContent. Se espera 900ms a que la seleccion se asiente, y cada
     variante se avisa UNA sola vez por carga: si no, cada clic en la paleta
     contaria como una vista y la cifra quedaria igual de inservible, solo que
     inflada en vez de corta. */
  var vistaPendiente = null;
  var vistasAvisadas = {};

  function avisarVista() {
    if (!window.Shopify || !Shopify.analytics || typeof Shopify.analytics.publish !== 'function') return;

    /* En las fichas de producto Shopify YA dispara `product_viewed`, y el
       panel de compra usa este mismo fichero. Sin esta guarda cada ficha
       contaria la vista dos veces y el numero quedaria inflado, que es el
       mismo problema al reves. Solo se avisa donde Shopify no llega: las
       paginas de coleccion donde vive el configurador. */
    var tipo = window.ShopifyAnalytics &&
               ShopifyAnalytics.meta &&
               ShopifyAnalytics.meta.page &&
               ShopifyAnalytics.meta.page.pageType;
    if (tipo === 'product') return;

    window.clearTimeout(vistaPendiente);
    vistaPendiente = window.setTimeout(function () {
      var v = varianteActual();
      var d = actual();
      if (!v || !d || vistasAvisadas[v.id]) return;
      vistasAvisadas[v.id] = true;

      try {
        Shopify.analytics.publish('strapion_colorway_viewed', {
          product_id: d.id || null,
          variant_id: v.id,
          handle: d.handle || null,
          title: d.title || null,
          price: (v.precio || 0) / 100,
          currency: (Shopify.currency && Shopify.currency.active) || 'USD'
        });
      } catch (e) {
        /* La analitica nunca debe romper el configurador. */
      }
    }, 900);
  }

  function pintarTodo() {
    pintarDesigns();
    pintarSwatches();
    pintarModelos();
    pintarImagen();
    pintarThumbs();
    pintarTiers();
    pintarMix();
    pintarCompra();
    avisarVista();
  }

  /* --- interaccion ------------------------------------------------------ */

  raiz.addEventListener('click', function (evento) {
    if (evento.target.closest('[data-sx-mix-toggle]')) {
      alternarMezcla();
      if (mezclaActiva()) irALaPaleta();
      return;
    }

    var hueco = evento.target.closest('[data-sx-mix-slot]');
    if (hueco) {
      estado.slot = Number(hueco.dataset.sxMixSlot);
      var yaElegido = estado.mezcla ? estado.mezcla[estado.slot] : null;
      if (yaElegido !== null && yaElegido !== undefined) verColorway(yaElegido);
      pintarTodo();
      irALaPaleta();
      return;
    }

    var design = evento.target.closest('[data-sx-design]');
    if (design) {
      var i = Number(design.dataset.sxDesign);
      if (mezclaActiva() && ejeMezcla() === 'design') { elegirEnHueco(i); return; }
      if (i === estado.design) return;
      estado.design = i;
      estado.color = 0;
      estado.model = 0;
      estado.foto = 0;
      pintarTodo();
      limpiarAviso();
      return;
    }

    var color = evento.target.closest('[data-sx-color]');
    if (color) {
      var c = Number(color.dataset.sxColor);
      if (mezclaActiva() && ejeMezcla() === 'color') { elegirEnHueco(c); return; }
      if (c === estado.color) return;
      estado.color = c;
      estado.foto = 0;
      pintarSwatches();
      pintarImagen();
      pintarThumbs();
      pintarTiers();
      pintarMix();
      pintarCompra();
      limpiarAviso();
      return;
    }

    var modelo = evento.target.closest('[data-sx-model]');
    if (modelo) {
      var m = Number(modelo.dataset.sxModel);
      if (m === estado.model) return;
      estado.model = m;
      pintarModelos();
      // La gama de colores depende del modelo: al cambiar de WHOOP 5.0 a MG
      // aparecen o desaparecen muestras, asi que hay que repintarlas.
      pintarSwatches();
      pintarTiers();
      pintarMix();
      pintarCompra();
      limpiarAviso();
      return;
    }

    var tier = evento.target.closest('[data-sx-tier]');
    if (tier) {
      var t = Number(tier.dataset.sxTier);
      if (t === estado.tier) return;
      estado.tier = t;
      pintarTiers();
      pintarMix();
      pintarCompra();
      limpiarAviso();
      return;
    }

    var foto = evento.target.closest('[data-sx-foto]');
    if (foto) {
      var f = Number(foto.dataset.sxFoto);

      /* Hasta 989px la foto grande esta plegada, asi que cambiar `estado.foto`
         no se ve. Ahi la vista se abre en la lupa. */
      if (window.matchMedia('(max-width: 989px)').matches) {
        abrirLupa(f);
        return;
      }

      if (f === estado.foto) return;
      estado.foto = f;
      pintarImagen();
      pintarThumbs();
    }
  });

  // Flechas dentro de cada grupo de opciones, como espera un radiogroup.
  raiz.addEventListener('keydown', function (evento) {
    if (evento.key !== 'ArrowLeft' && evento.key !== 'ArrowRight') return;
    var grupo = evento.target.closest('[role="radiogroup"]');
    if (!grupo) return;

    var botones = Array.prototype.slice.call(grupo.querySelectorAll('[role="radio"]')).filter(function (b) {
      return !b.disabled;
    });
    var i = botones.indexOf(evento.target);
    if (i < 0) return;

    evento.preventDefault();
    var siguiente = botones[(i + (evento.key === 'ArrowRight' ? 1 : botones.length - 1)) % botones.length];
    siguiente.click();
    var reciente = grupo.querySelectorAll('[role="radio"]')[botones.indexOf(siguiente)];
    if (reciente) reciente.focus();
  });

  /* --- carrito ---------------------------------------------------------- */

  var temporizadorAviso;

  function limpiarAviso() {
    window.clearTimeout(temporizadorAviso);
    el.feedback.textContent = '';
    el.feedback.className = 'sx-feedback';
  }

  function avisar(texto, tipo) {
    window.clearTimeout(temporizadorAviso);
    el.feedback.textContent = texto;
    el.feedback.className = 'sx-feedback is-visible' + (tipo ? ' sx-feedback--' + tipo : '');
    temporizadorAviso = window.setTimeout(limpiarAviso, 6000);
  }

  el.add.addEventListener('click', function () {
    var v = varianteActual();
    if (!v || el.add.classList.contains('is-cargando')) return;

    var problema = problemaMezcla();
    if (problema) { avisar(problema, 'error'); return; }
    if (!mezclaActiva() && !v.disponible) return;

    el.add.classList.add('is-cargando');

    fetch(raizTienda + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: lineasDelPack(v),
        // Pedimos el cajon ya renderizado para no dejarlo desfasado.
        sections: 'cart-drawer-section'
      })
    })
      .then(function (respuesta) {
        return respuesta.json().then(function (cuerpo) {
          if (!respuesta.ok) throw new Error(cuerpo.description || cuerpo.message || 'Could not add to cart');
          return cuerpo;
        });
      })
      .then(function (cuerpo) {
        if (cuerpo.sections && cuerpo.sections['cart-drawer-section']) {
          var destino = document.getElementById('shopify-section-cart-drawer-section');
          if (destino) {
            var envoltorio = document.createElement('div');
            envoltorio.innerHTML = cuerpo.sections['cart-drawer-section'];
            var nuevo = envoltorio.querySelector('#shopify-section-cart-drawer-section');
            if (nuevo) destino.replaceWith(nuevo);
          }
        }

        // El tema y el contador de la cabecera escuchan este evento.
        document.dispatchEvent(
          new CustomEvent('shopify:cart:lines-update', {
            bubbles: true,
            detail: { source: 'strapion-configurador', action: 'add' }
          })
        );

        abrirCajon();

        var cant = tramoActual().cant;
        if (mezclaActiva()) {
          avisar('Added ×' + cant + ' — ' + estado.mezcla.map(nombreDeOpcion).join(', '), 'ok');
        } else {
          var d = actual();
          var color = d.colores[estado.color];
          avisar(
            'Added' + (cant > 1 ? ' ×' + cant : '') + ' — ' + d.corto + (color ? ', ' + color.nombre : ''),
            'ok'
          );
        }

        el.add.classList.add('is-hecho');
        window.setTimeout(function () { el.add.classList.remove('is-hecho'); }, 1800);
      })
      .catch(function (error) {
        avisar(error.message || 'Could not add to cart', 'error');
      })
      .then(function () {
        el.add.classList.remove('is-cargando');
      });
  });

  /* --- Lupa de la foto ---------------------------------------------------
     En movil y tablet la zona fijada ensena las vistas pequenas, asi que al
     tocarlas no pasaba nada visible: no hay foto grande a la que cambiar. La
     lupa las abre a tamano medio sobre un fondo desenfocado, sin llevarse la
     pagina a otra pantalla. */
  var lupa = null;
  var lupaFotos = [];
  var lupaIndice = 0;

  function montarLupa() {
    if (lupa) return lupa;

    lupa = document.createElement('div');
    lupa.className = 'sx-lupa';
    lupa.setAttribute('role', 'dialog');
    lupa.setAttribute('aria-modal', 'true');
    lupa.setAttribute('aria-label', 'Product photo');
    lupa.hidden = true;
    lupa.innerHTML =
      '<button type="button" class="sx-lupa__cerrar" aria-label="Close">&times;</button>' +
      '<figure class="sx-lupa__caja"><img class="sx-lupa__img" alt=""></figure>' +
      '<div class="sx-lupa__puntos" role="tablist"></div>';

    /* Un solo oyente: el fondo cierra, y los controles se distinguen por su
       marca. Asi no hay que recablear nada al repintar los puntos. */
    lupa.addEventListener('click', function (evento) {
      var punto = evento.target.closest('[data-sx-lupa-punto]');
      if (punto) { verEnLupa(Number(punto.dataset.sxLupaPunto)); return; }
      if (evento.target.closest('.sx-lupa__img')) return;
      cerrarLupa();
    });

    document.body.appendChild(lupa);
    return lupa;
  }

  function verEnLupa(i) {
    if (!lupaFotos.length) return;
    lupaIndice = (i + lupaFotos.length) % lupaFotos.length;
    lupa.querySelector('.sx-lupa__img').src = lupaFotos[lupaIndice];

    var puntos = lupa.querySelector('.sx-lupa__puntos');
    puntos.innerHTML = '';
    if (lupaFotos.length < 2) return;

    lupaFotos.forEach(function (url, n) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sx-lupa__punto' + (n === lupaIndice ? ' is-activo' : '');
      b.dataset.sxLupaPunto = String(n);
      b.setAttribute('aria-label', 'View ' + (n + 1));
      b.setAttribute('aria-selected', n === lupaIndice ? 'true' : 'false');
      puntos.appendChild(b);
    });
  }

  function abrirLupa(i) {
    lupaFotos = fotosActuales();
    if (!lupaFotos.length) return;

    montarLupa();
    verEnLupa(i);

    lupa.hidden = false;
    /* El fotograma de espera es para que la clase de entrada se aplique sobre
       un elemento ya visible; si no, la transicion no llega a arrancar. */
    window.requestAnimationFrame(function () { lupa.classList.add('is-abierta'); });

    document.documentElement.classList.add('sx-lupa-abierta');
    lupa.querySelector('.sx-lupa__cerrar').focus();
  }

  function cerrarLupa() {
    if (!lupa || lupa.hidden) return;
    lupa.classList.remove('is-abierta');
    document.documentElement.classList.remove('sx-lupa-abierta');

    var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (quieto) { lupa.hidden = true; return; }
    window.setTimeout(function () { if (!lupa.classList.contains('is-abierta')) lupa.hidden = true; }, 220);
  }

  document.addEventListener('keydown', function (evento) {
    if (!lupa || lupa.hidden) return;
    if (evento.key === 'Escape') { cerrarLupa(); return; }
    if (evento.key === 'ArrowLeft') { verEnLupa(lupaIndice - 1); }
    if (evento.key === 'ArrowRight') { verEnLupa(lupaIndice + 1); }
  });

  pintarTodo();
  refrescarEnvio();
  }
})();
